import EventiMenuList from "./components/EventiMenuList.vue";
import EventiMenuView from "./components/EventiMenuView.vue";
import EventiMenuEdit from "./components/EventiMenuEdit.vue";

export default {
    EventiMenuList,
    EventiMenuView,
    EventiMenuEdit,
};
